import { render, staticRenderFns } from "./LocaleVerifyBatchImportDialog.vue?vue&type=template&id=4b0b4418&scoped=true"
import script from "./LocaleVerifyBatchImportDialog.vue?vue&type=script&lang=js"
export * from "./LocaleVerifyBatchImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b4418",
  null
  
)

export default component.exports